<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial ">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioDesembolso" name="nomFormularioDesembolso">
    <div class="col-12 form-group">
      <div class="lg:col-4 lg:col-offset-4">
        <div class="div-form lg:col-12">
          <label>* {{'PRODUCTOREFERENCIA.LBL_REFTITULARTITLE' | translate}}:</label>
          <p-multiSelect id="idFormaDesembolso" name="nomIdFormaDesembolso" [options]="listDesembolsos" filter="filter"
                         defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                         selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idFormaDesembolso"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && formulario.invalid">
            {{ 'PRODUCTOREFERENCIA.LBL_REFTITULARTITLE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
          <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
  </form>
</div>

<p-confirmDialog #cd key="referencias-metodos-desembolso">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
